export class DbBlockedError extends Error {
  constructor() {
    super("One or more other tabs/windows have an older version of the website open. Close all other open tabs/windows of this website and then refresh this page.");
    this.name = "DbBlockedError";
  }
}